import { clearAllBodyScrollLocks, disableBodyScroll } from 'body-scroll-lock';
import { _breakP } from './utils.js';
export default class modal {
  constructor() {
    this.modalFunction();
  }

  modalFunction() {
    const $modal = document.querySelectorAll('.js-modal');

    const focusableSelector = 'a[href], button:not([disabled]), textarea:not([disabled]), input:not([disabled]), select:not([disabled]), [tabindex]:not([tabindex="-1"])';

    let trapFocusHandler = null;
    let escKeyHandler = null;
    let lastFocusedElement = null;

    function setupFocusTrap(modalElement, closeCallback) {
      const focusableElements = modalElement.querySelectorAll(focusableSelector);
      const firstFocusable = focusableElements[0];
      const lastFocusable = focusableElements[focusableElements.length - 1];

      trapFocusHandler = function(e) {
        if (e.key !== 'Tab') return;

        if (e.shiftKey) {
          if (document.activeElement === firstFocusable) {
            e.preventDefault();
            lastFocusable.focus();
          }
        } else {
          if (document.activeElement === lastFocusable) {
            e.preventDefault();
            firstFocusable.focus();
          }
        }
      };

      escKeyHandler = function(e) {
        if (e.key === 'Escape') {
          closeCallback();
        }
      };

      modalElement.addEventListener('keydown', trapFocusHandler);
      document.addEventListener('keydown', escKeyHandler);

      if (firstFocusable) {
        firstFocusable.focus();
      }
    }

    function removeFocusTrap(modalElement) {
      if (trapFocusHandler) {
        modalElement.removeEventListener('keydown', trapFocusHandler);
        trapFocusHandler = null;
      }
      if (escKeyHandler) {
        document.removeEventListener('keydown', escKeyHandler);
        escKeyHandler = null;
      }
    }

    function modalClose(e) {
      if (!e.classList.contains('is-visible')) return;
      e.classList.remove('is-visible');
      e.setAttribute('aria-hidden', 'true');
      clearAllBodyScrollLocks();
      removeFocusTrap(e);
      if (lastFocusedElement) {
        lastFocusedElement.focus();
      }
    }

    function modalOpen(e, triggerElement) {
      lastFocusedElement = triggerElement || document.activeElement;
      e.classList.add('is-visible');
      e.setAttribute('aria-hidden', 'false');
      const $target = e.querySelector('.js-modalInner');
      disableBodyScroll($target);
      setupFocusTrap(e, () => modalClose(e));
    }

    function setupModalAttributes(modalElement, index) {
      // Lenis(scroll.js のJS制御スクロール)は wheel / touchmove を preventDefault するため、
      // 目印を付けないとモーダル内のスクロール領域がホイールでも指でも動かない。
      // (body-scroll-lock でページをロックすると Lenis は stop 状態になり、
      //  stop 中は無条件に preventDefault するため、モーダル側で明示的に除外する必要がある)
      const $modalInner = modalElement.querySelector('.js-modalInner');
      if ($modalInner) {
        $modalInner.setAttribute('data-lenis-prevent', '');
      }

      const modalId = `modal-${index}`;
      const titleId = `modal-title-${index}`;
      modalElement.setAttribute('role', 'dialog');
      modalElement.setAttribute('aria-modal', 'true');
      modalElement.setAttribute('aria-hidden', 'true');
      modalElement.setAttribute('id', modalId);

      const titleElement = modalElement.querySelector('.generalModal__ttl, .movieModal__ttl, h2, h3');
      if (titleElement) {
        titleElement.setAttribute('id', titleId);
        modalElement.setAttribute('aria-labelledby', titleId);
      } else {
        modalElement.setAttribute('aria-label', 'モーダルウィンドウ');
      }
    }

    function modalContDOMMove(e, i) {
      const $modalDomMovedPoint = document.querySelector('.currentPage');
      const $modalCont = e.querySelector('.js-modalCont');
      $modalCont.classList.add(`js-modalCont--${i}`);
      $modalDomMovedPoint.insertAdjacentHTML('afterbegin', $modalCont.outerHTML);
      $modalCont.remove();
      const $movedModalCont = document.querySelector(`.js-modalCont--${i}`);
      return $movedModalCont;
    }

    if ($modal.length) {

      $modal.forEach((modalElm, index) => {
        function modalStruct() {
          const $modalCont = modalContDOMMove(modalElm, index);
          setupModalAttributes($modalCont, index);
          const $modalBtn = modalElm.querySelectorAll('.js-modalBtn');
          const $closeBtn = $modalCont.querySelectorAll('.js-modalClose');

          $closeBtn.forEach(btn => {
            if (!btn.getAttribute('aria-label')) {
              btn.setAttribute('aria-label', '閉じる');
            }
          });
          const $ytFrame = $modalCont.querySelector('.js-yt-frame');

          if ($ytFrame) {
            window.onYouTubeIframeAPIReady = function () {
              const dataYT = $ytFrame.dataset.ytId;
              const ytWidth = 1260;
              const ytHeight = 708.75;

              const ytID = dataYT;
              const ytPlayer = new YT.Player($ytFrame, {
                height: ytHeight,
                width: ytWidth,
                videoId: ytID,

                playerVars: {
                  showinfo: 0,
                  rel: 0,
                  origin: location.protocol + '//' + location.hostname + '/'
                },
                events: {
                  onReady: onPlayerReady
                }
              });

              $modalBtn.forEach(elm => {
                elm.addEventListener('click', () => {
                  ytPlayer.playVideo();
                });
              });

              $closeBtn.forEach(elm => {
                elm.addEventListener('click', () => {
                  ytPlayer.pauseVideo();
                });
              });

              function onPlayerReady() {}
            }
          }

          $modalBtn.forEach(elm => {
            elm.addEventListener('click', event => {
              event.preventDefault();
              modalOpen($modalCont, elm);
            });
          });

          $closeBtn.forEach(elm => {
            elm.addEventListener('click', event => {
              event.preventDefault();
              modalClose($modalCont);
            });
          });
        }

        if (modalElm.dataset.modalDevice === 'sp') {
          _breakP.SP ? modalStruct() : null;
        } else if (modalElm.dataset.modalDevice === 'pc') {
          !_breakP.SP ? modalStruct() : null;
        } else {
          modalStruct();
        }
      });
    }
  }
}
